// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_AddressModel from '../../model/tdg-address-model';
import Tdg_AddressDTO from '../dto/tdg-address-dto';
import dtoSchema from '../schemas/tdg-address-schema';

export default abstract class Tdg_AddressModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_AddressDTO>) {
    super();
    if (data) {
      this.street = data.street ?? undefined;
      this.houseNumber = data.houseNumber ?? undefined;
      this.city = data.city ?? undefined;
      this.postalCode = data.postalCode ?? undefined;
    }
  }
  /**
  */
  street?: string;
  /**
  */
  houseNumber?: string;
  /**
  */
  city?: string;
  /**
  */
  postalCode?: string;

  static toModel(dto: DeepPartial<Tdg_AddressDTO>): Tdg_AddressModel;
  static toModel(dto: DeepPartial<Tdg_AddressDTO> | undefined | null): Tdg_AddressModel | undefined;
  static toModel(dto: DeepPartial<Tdg_AddressDTO> | undefined | null): Tdg_AddressModel | undefined {
    return dto ? new Tdg_AddressModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_AddressModel> | Tdg_AddressModel): Tdg_AddressDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      street: unwrapped.street,
      houseNumber: unwrapped.houseNumber,
      city: unwrapped.city,
      postalCode: unwrapped.postalCode,
    } as Tdg_AddressDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_AddressModel, can not map to Tdg_AddressDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
